// Point d'entrée JS moderne, empaqueté par esbuild (`pnpm build`, script
// `build` de package.json) vers app/assets/builds/application.js, puis servi
// par Propshaft via `javascript_include_tag "application"`.
//
// Le JS historique (jQuery, cocoon, autocomplete…) vit à côté dans
// app/javascript/legacy.js, troisième point d'entrée du même appel esbuild.
//
// esbuild ne doit émettre AUCUN CSS ici : il écraserait les application.css /
// client.css que dart-sass écrit dans le même app/assets/builds. Les styles de
// flatpickr sont vendorisés dans app/assets/stylesheets/_flatpickr.scss.

// rails-ujs est la SEULE source d'UJS de l'application : il était servi par
// Sprockets (app/assets/javascripts/client.js) ET tiré dans le manifeste
// historique via require_tree ; il ne vient plus que d'ici. Deux chargements
// lèveraient "Error: rails-ujs has already been loaded!".
import Rails from "@rails/ujs";
Rails.start();

import "@rails/actiontext";
import "trix";
import "./controllers";
